<script>
import BaseVolanInputValidate from './BaseVolanInputValidate';
import InputText from 'primevue/inputtext';
/**
 * Componente para input de texto, numérico ou outro input quelquer
 *
 * Substitui o componente VTextField
 *
 * [Wraper para inputtext](https://primevue.org/inputtext)
 *
 * @displayName VolanInput (VTextField)
 */
export default {
  name: 'VolanInput',
  components: {InputText},
  extends: BaseVolanInputValidate,
  inheritAttrs: false,
  props: {
    /**
     * O tipo do input
     * @values text, password, radio, range, reset, search, tel, time, url, week, button, checkbox,
     * color, date, datetime-local, email, file, hidden, image, month
     */
    type: {
      type: String, // tipos aceitos pelo html https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#input_types
      default: 'text',
    },
  },
};
</script>

<template>
  <div class="field volanTextContainer mt-2 mb-2 pt-1">
    <label v-if="computedLabel || !hideDetails"
           class="block"
           :for="computedId"
    >{{ computedLabel }}</label>
    <InputText :id="computedId"
               v-bind="$attrs"
               :value="value"
               class="block"
               :class="{'p-invalid': isValid===false}"
               :disabled="isDisabled"
               :readonly="isReadonly"
               v-on="$listeners"
    />
    <small v-for="(message, index) of internalErrorMessages"
           :key="index"
           class="p-error block"
    >{{ message }}</small>
    <small v-if="!internalErrorMessages.length && !hideDetails"
           class="block"
    >{{ hintComputed }}</small>
  </div>
</template>

<style lang="scss">
.volanTextContainer {
  small {
    min-height: 1.5em;
  }
}
</style>